import React, { PropsWithChildren } from 'react';
import ReactDOM from 'react-dom';
import { Tooltip } from 'react-tooltip';
import QuestionMarkIcon from 'assets/images/QuestionMarkIcon';
import Switcher from 'components/Switcher/Switcher';
import styles from './index.module.scss';

type Props = PropsWithChildren<{
  isOpen: boolean;
  onClose: () => void;
  size?: 'xl' | 'lg' | 'md';
  title?: string;
  toggleText?: string;
  toggleHandler?: (_value: boolean) => void;
  tooltipText?: string;
  maxWidth?: number;
}>;

const Modal: React.FC<Props> = (props) => {
  const {
    children,
    isOpen,
    onClose,
    size,
    title,
    toggleText,
    toggleHandler,
    tooltipText,
    maxWidth,
  } =
    props;

  if (!isOpen) {
    return null;
  }

  return (
    <>
      {ReactDOM.createPortal(
        <div className="modal-backdrop fade show" />,
        document.getElementById('backdrop-root') as HTMLDivElement,
      )}
      {ReactDOM.createPortal(
        <div
          className={`modal ${styles.modal}`}
          onClick={onClose}
          role="none"
        >
          <div
            className={`modal-dialog modal-dialog-scrollable modal-dialog-centered modal-${
              size ?? ''
            }`}
            style={{ width: maxWidth ? `${maxWidth}px` : '' }}
            onClick={(event): void => event.stopPropagation()}
            role="none"
          >
            <div className="modal-content">
              {title && (
                <div className="modal-header">
                  <h5 className="modal-title">
                    {title}
                    {tooltipText && (
                      <div
                        data-tooltip-id="icon-title-tooltip"
                        data-tooltip-content={tooltipText}
                        className={styles.titleIconWrapper}
                      >
                        <QuestionMarkIcon />
                        { tooltipText && (<Tooltip id="icon-title-tooltip" />)}
                      </div>
                    )}
                  </h5>
                  {toggleText && toggleHandler && (
                    <div className={styles.switcherWrapper}>
                      <Switcher prefix="modal_" onChange={toggleHandler} lable={toggleText} />
                    </div>
                  )}
                  <button
                    onClick={onClose}
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                  />
                </div>
              )}
              {children}
            </div>
          </div>
        </div>,
        document.getElementById('modal-root') as HTMLDivElement,
      )}
    </>
  );
};

export default Modal;
